<div
    class="p-element p-inputwrapper m-2lvl-select"
    #dropDown
    [ngStyle]="ngStyle"
>
    <div
        class="p-component p-select m-2lvl-select-button"
        #header
        [ngStyle]="ngStyleHeader"
        (click)="!disabled && toggleExpanded()"
    >
        <span class="p-select-label p-inputtext">
            {{ selectedFirstLevel?.label }} {{ wordBetweenOptionsTranslation | translate }}
            {{ selectedSecondLevel?.label | lowercase }}
        </span>

        <div
            class="p-select-trigger"
            style="width: 2rem"
        >
            <span class="p-select-trigger-icon pi pi-chevron-down"></span>
        </div>
    </div>
</div>

<div
    class="p-select-overlay p-component m-2lvl-select-dropdown"
    #dropDownPart
    [ngStyle]="ngStyleExpandablePart"
    style="display: none"
>
    <div class="p-select-list-container m-2lvl-select-dropdown-wrapper flex">
        <!-- First level -->
        @if (firstLevelOptions) {
            <ul
                class="m-2lvl-select-lvl1 p-select-list"
                style="width: 100%"
            >
                @for (firstLevelOption of firstLevelOptions; track firstLevelOption?.value) {
                    <li
                        class="p-element p-select-option"
                        [ngClass]="
                            firstLevelOption?.value === selectedFirstLevel?.value ? ['p-select-option-selected'] : ['']
                        "
                        (click)="!disabled && handleFirstLevelSelect(firstLevelOption)"
                    >
                        {{ firstLevelOption.label }}
                    </li>
                }
            </ul>
        }

        <!-- Second Level -->
        @if (secondLevelOptions) {
            <ul
                class="m-2lvl-select-lvl2 p-select-list"
                style="width: 100%"
            >
                @for (secondLevelOption of secondLevelOptions; track secondLevelOption?.value) {
                    <li
                        class="p-element p-select-option"
                        [ngClass]="
                            secondLevelOption?.value === selectedSecondLevel?.value
                                ? ['p-select-option-selected']
                                : secondLevelOption.disabled
                                  ? ['p-disabled']
                                  : ['item-with-cursor-pointer', 'not-selected-item']
                        "
                        (click)="!disabled && handleSecondLevelSelect(secondLevelOption)"
                    >
                        {{ secondLevelOption.label }}
                    </li>
                }
            </ul>
        }
    </div>
</div>
